import { useMe } from '@scout/identity'
import { ChatIcon } from '@scout/ui/icons'
import { SidebarItem, sidebarActiveProps } from '@scout/ui/sidebar'
import { Link } from '@tanstack/react-router'

/**
 * The sidebar's way to the briefs list.
 *
 * Renders nothing for a visitor who is nobody, and nothing while that is still
 * being decided. An anonymous visitor has one brief, reached through the cookie
 * that holds it — a list would be a page with one thing on it behind a door
 * that says there are several.
 */
export function BriefsLink() {
  const who = useMe()

  if (!who.settled || who.person === null) return null

  return (
    <SidebarItem asChild>
      <Link to="/app/briefs" activeProps={sidebarActiveProps}>
        <ChatIcon />
        Briefs
      </Link>
    </SidebarItem>
  )
}
